import React, { Component } from "react";
import { Button, Table, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import _ from "lodash";
import ReportSelection from "./ReportSelection";
import { ERR_SELECT_ITEM_IN_LIST } from "../../ErrorMessages";

class SelectReport extends Component {
  constructor(props) {
    super(props);
    this.nameSelectRef = React.createRef();
    this.state = {
      internalNameID: props.nameCollections.length === 1 ? "1" : "-1",
      error: ERR_SELECT_ITEM_IN_LIST,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.nameCollections.length === 1) {
      this.setState({ internalNameID: "1", error: "" });
    }
  }

  onGetMoreDetailsClick = (e, optReportType) => {
    if (this.state.internalNameID === "-1") {
      this.setState({ error: ERR_SELECT_ITEM_IN_LIST });
      setTimeout(() => {
        this.nameSelectRef.current.toggle();
      }, 100);
      return;
    }
    const isGoldReport = optReportType === "compgold";
    let reportName;
    let reportApiName;
    if (optReportType === "persummary") {
      reportName = "Person/MoreDetails";
      reportApiName = "personReport";
    } else {
      reportApiName = "PersonReport";
    }
    this.setState({ displayMoreDetails: false });
    this.props.showReport(reportName, reportApiName, this.props.internalId, {
      internalNameID: this.state.internalNameID,
      bttype: this.props.userAccount.btType,
      optReportType:
        this.props.optReportType !== undefined &&
        this.props.optReportType !== ""
          ? this.props.optReportType
          : optReportType,
      requestedSection: this.props.requestedSection,
      ignoreReportId: true,
      isGoldReport,
    });
  };

  nameChanged = (e, data) => {
    this.setState({
      internalNameID: data.value,
      error: data.value === "-1" ? ERR_SELECT_ITEM_IN_LIST : "",
    });
    if (this.props.onNameSelect) {
      this.props.onNameSelect(data.value);
    }
  };

  showNameSelectionError = () => {
    setTimeout(() => {
      this.nameSelectRef.current.toggle();
    }, 100);
    this.setState({ error: ERR_SELECT_ITEM_IN_LIST });
  };

  render() {
    const options = [];
    const { userAccount } = this.props;
    if (this.props.nameCollections.length > 1)
      options.push({
        key: "-1",
        value: "-1",
        text: "Select A Name/Alias",
      });
    _.forEach(this.props.nameCollections, (nameDetail) => {
      options.push({
        key: nameDetail.internalNameID,
        value: nameDetail.internalNameID,
        text: nameDetail.name,
      });
    });
    const { additionalData, isGoldReport } = this.props;

    let isSilverReport = this.props.isSilverReport;
    if (isGoldReport) isSilverReport = false;
    let reportCost = "";
    if (isSilverReport && additionalData && additionalData.reportCost) {
      reportCost = additionalData.reportCost;
    }

    return (
      <Table className={`table-no-border no-print`}>
        <Table.Body>
          {isSilverReport && (
            <Table.Row className="report-sub-section-header text-bold">
              <Table.Cell width={4} className="icon-align-middle text-right">
                <b>{this.props.selectReportTitle}:</b>
              </Table.Cell>
              <Table.Cell width={6} className={"text-center icon-align-middle"}>
                <Dropdown
                  className="select-report-name"
                  fluid
                  options={options}
                  search
                  selection
                  selectOnBlur={false}
                  id={`report_id_${this.state.internalNameID}`}
                  value={this.state.internalNameID}
                  onChange={this.nameChanged}
                  key={`name_${this.state.internalNameID}`}
                  ref={this.nameSelectRef}
                />
                {options.length > 1 && this.state.error !== "" && (
                  <span>
                    <span className={"red-text"}>{this.state.error}</span>
                  </span>
                )}
              </Table.Cell>
              <Table.Cell width={4}>
                <Button
                  primary
                  onClick={(e) => this.onGetMoreDetailsClick(e, "compsilver")}
                >
                  View Report
                  {`${reportCost !== "" ? ` - ${reportCost}` : ""}`}
                </Button>
              </Table.Cell>
            </Table.Row>
          )}
          {!isSilverReport && (
            <Table.Row
              className={
                userAccount.acctTheme === 0
                  ? "newReportSelectionContainerHeader roundedCorners10 box-shadow"
                  : "report-sub-section-header text-bold"
              }
            >
              <Table.Cell width={6} className="icon-align-middle text-right">
                <b>{this.props.selectReportTitle}:</b>
              </Table.Cell>
              <Table.Cell width={6} className={"text-center"}>
                <Dropdown
                  className="select-report-name padding-5 report-dropdown"
                  style={{ minWidth: "300px" }}
                  fluid
                  options={options}
                  search
                  selection
                  selectOnBlur={false}
                  id={`report_id_${this.state.internalNameID}`}
                  value={this.state.internalNameID}
                  onChange={this.nameChanged}
                  key={`name_${this.state.internalNameID}`}
                  ref={this.nameSelectRef}
                />
                {options.length > 1 && this.state.error !== "" && (
                  <span>
                    <span className={"red-text"}>{this.state.error}</span>
                  </span>
                )}
              </Table.Cell>
            </Table.Row>
          )}

          {!isSilverReport && (
            <Table.Row>
              <Table.Cell colSpan={2}>
                <ReportSelection
                  {...this.props}
                  internalNameID={this.state.internalNameID}
                  showNameSelectionError={this.showNameSelectionError}
                  isGoldReport={this.props.isGoldReport}
                />
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    );
  }
}

function mapStateToProps(state) {
  return {
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(SelectReport);



// WEBPACK FOOTER //
// ./src/components/searchresults/SelectReport.js